import { ISelected } from '../../reducers/selected';
import { ITypedReduxAction } from '../../types/redux';
import { actionGenerator } from '../../utils/redux';

export enum ESelectedActionTypes {
  Select = 'SELECTED :: SELECT',
  Unselect = 'SELECTED :: UNSELECT',
  SelectAll = 'SELECTED :: SELECT_ALL',
  UnselectAll = 'SELECTED :: UNSELECT_ALL',
}

export interface ISelectActionPayload {
  entityId: number;
  entityType: string;
  fullUrl: string;
}

export interface ISelectAllActionPayload {
  ids: ISelected;
}

export interface IUnselectActionPayload {
  entityId: number;
  entityType: string;
}

export type TSelectedActions =
  | ITypedReduxAction<ESelectedActionTypes.Select, ISelectActionPayload>
  | ITypedReduxAction<ESelectedActionTypes.Unselect, IUnselectActionPayload>
  | ITypedReduxAction<ESelectedActionTypes.SelectAll, ISelectAllActionPayload>
  | ITypedReduxAction<ESelectedActionTypes.UnselectAll, void>;

export const select: (payload: ISelectActionPayload) => TSelectedActions = actionGenerator<
  ESelectedActionTypes.Select,
  ISelectActionPayload
>(ESelectedActionTypes.Select);

export const unselect: (payload: IUnselectActionPayload) => TSelectedActions = actionGenerator<
  ESelectedActionTypes.Unselect,
  IUnselectActionPayload
>(ESelectedActionTypes.Unselect);

export const selectAll: (payload: ISelectAllActionPayload) => TSelectedActions = actionGenerator<
  ESelectedActionTypes.SelectAll,
  ISelectAllActionPayload
>(ESelectedActionTypes.SelectAll);

export const unselectAll: () => TSelectedActions = actionGenerator<ESelectedActionTypes.UnselectAll>(
  ESelectedActionTypes.UnselectAll,
);
